<template>
  <div>
    <div id="modal-preview-auto" class="modal fade" aria-hidden="true" ref="orderPreviewAuto">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Review data</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-6">
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right"><dt>Type:</dt> </div>
                        <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">
                            <span class="label label-primary" v-if="autoReplaceData.filters.typePost">Post</span>
                            <span class="label label-default" v-if="autoReplaceData.filters.typePage">Page</span>
                          </dd>
                        </div>
                      </dl>
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right"><dt>Language:</dt> </div>
                        <div class="col-sm-8 text-sm-left"><dd class="mb-1">{{ autoReplaceData.filters.lang || "Any" }}</dd></div>
                      </dl>
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right"><dt>&nbsp;</dt> </div>
                        <div class="col-sm-8 text-sm-left"><dd class="mb-1">&nbsp;</dd></div>
                      </dl>
                    </div>
                    <div class="col-lg-6">
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                          <dt>RD:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{ autoReplaceData.filters.rdFrom || 0 }} - {{ autoReplaceData.filters.rdTo || '∞' }}</dd>
                        </div>
                      </dl>
                    </div>
                    <div class="col-lg-6">
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                          <dt>TF:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{ autoReplaceData.filters.tfFrom || 0 }} - {{ autoReplaceData.filters.tfTo || '∞' }}</dd>
                        </div>
                      </dl>
                    </div>
                    <div class="col-lg-6">
                      <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                          <dt>DA:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{ autoReplaceData.filters.daFrom || 0 }} - {{ autoReplaceData.filters.daTo || '∞' }}</dd>
                        </div>
                      </dl>
                    </div>
                    <div class="row">
                      <div class="col-lg-12"><button class="btn btn-primary" @click="fulfilOrder">Fulfil</button></div>
                    </div>
                  </div>
                  <div class="row">
                    <table class="table small">
                      <thead>
                      <tr>
                        <th>Search</th>
                        <th>Replace</th>
                        <th>Link</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(rep, index) in autoReplaceData.replacements" v-bind:key="index">
                        <td>{{ rep.search }}</td>
                        <td>{{ rep.replace }}</td>
                        <td>{{ rep.link }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-replace" class="modal fade" aria-hidden="true" ref="orderReplace">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Replacements</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-3"><label for="oAutoSearch">Search</label></div>
                    <div class="col-lg-9"><input type="text" name="search" id="oAutoSearch" ref="oAutoSearch" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oAutoReplace">Replace</label></div>
                    <div class="col-lg-9"><input type="text" name="replace" id="oAutoReplace" ref="oAutoReplace" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oAutoLink">Link</label></div>
                    <div class="col-lg-9"><input type="text" name="link" id="oAutoLink" ref="oAutoLink" placeholder="http://" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oAutoNumber">Number</label></div>
                    <div class="col-lg-9"><input type="number" name="number" id="oAutoNumber" ref="oAutoNumber" min="1" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12"><button class="btn btn-primary" @click="addAutoReplace">Save</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-upload-csv" class="modal fade" aria-hidden="true" ref="orderReplace">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Upload csv file with links</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-3"><label for="oAutoSearch">File</label></div>
                    <div class="col-lg-9"><input type="file" name="csvfile" id="oCsvFile" ref="oCsvFile" class="col-lg-12" v-on:change="handleFile"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12"><button class="btn btn-primary" @click="uploadCsvFile">Upload</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-order" class="modal fade" aria-hidden="true" ref="addOrder">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">Add new order</h3></div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <div class="row">
                    <div class="col-lg-3"><label for="oAnchor">Anchor</label></div>
                    <div class="col-lg-9"><input type="text" name="anchor" id="oAnchor" ref="oAnchor" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oLink">Link</label></div>
                    <div class="col-lg-9"><input type="text" name="link" id="oLink" ref="oLink" placeholder="http://" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3"><label for="oNumber">Number</label></div>
                    <div class="col-lg-9"><input type="number" name="number" id="oNumber" ref="oNumber" min="1" class="col-lg-12"></div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12"><button class="btn btn-primary" @click="addOrder">Save</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-form" class="modal fade" aria-hidden="true" ref="updatePost" v-if="postLoaded">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="col-lg-12"><h3 class="m-t-none m-b">{{ post.title }}</h3>
              <p>Modified: {{ $moment(post.modified.date).calendar() }}</p>
                <div class="form-group">
                  <div id="editorRow">
                    <editor ref="editor" v-model="post.content"
                              :init="{
                    relative_urls:false,
                    fix_list_elements:true,
                    entities:'38,amp,60,lt,62,gt',
                    entity_encoding:'raw',
                    keep_styles:false,
                    branding:false,
                    forced_root_block : false,
                    force_false_newlines : true,
                    convert_newlines_to_brs : true,
                    indent: true,
                    plugins: 'code searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help',
                    toolbar1:'code formatselect,bold,italic,bullist,numlist,blockquote,alignleft,aligncenter,alignright,link,wp_more,spellchecker,dfw,wp_adv',
                    toolbar2:'strikethrough,hr,forecolor,pastetext,removeformat,charmap,outdent,indent,undo,redo,wp_help',
                    toolbar3:'',
                    toolbar4:'',
                    tabfocus_elements:'content-html,save-post',
                    body_class:'content post-type-post post-status-publish post-format-standard page-template-default locale-en-us',add_unload_trigger:false,
                    height: 300
                  }"></editor>
                    <div class="form-group">
                      <button class="btn btn-sm btn-primary float-right m-t-n-xs" type="button" @click="savePost" ref="saveBtn"><strong>Save and log</strong></button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row m-b-lg m-t-lg">
        <div class="col-md-6">
          <h4>{{ client.name }}</h4>
          <button class="btn btn-sm btn-primary float-right m-t-n-xs" data-toggle="modal" data-target="#modal-order">New order</button>
        </div>
        <div class="col-md-6">
          <table class="table small m-b-xs">
            <tbody>
            <tr v-for="(value, key) in client.data" :key="key">
              <td>
                {{ key }}
              </td>
              <td>
                <strong>{{ value }}</strong>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
<!--          <post-search :langs="this.languages" :order="this.order"></post-search> !-->
          <div class="ibox" v-if="order">
            <div class="ibox-title">Order details</div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="col-md-9 col-lg-9">
                    <form action="" id="postRestrictions">
                      <div class="search-form col-lg-12">
                        <div class="input-group col-lg-12">
                          <div class="ibox-content">
                            <div class="row">
                              <div class="col-lg-12">
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="typePost">Type:</label></div>
                                <div class="col-lg-8">
                                  <div class="col-lg-4">
                                    <input type="checkbox" name="type[post]" id="typePost"> Posts
                                  </div>
                                  <div class="col-lg-4">
                                    <input type="checkbox" name="type[page]" id="typePage"> Pages
                                  </div>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iLang">Language:</label></div>
                                <div class="col-lg-8">
                                  <select name="language" id="iLang" class="col-lg-8" ref="language">
                                    <option value="">---</option>
                                    <option :value="key" v-for="(lang, key) in languages" v-bind:key="key">{{ lang }}</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iTitle">Title:</label></div>
                                <div class="col-lg-8">
                                  <input type="text" name="title" id="iTitle" class="col-lg-12">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row m-t-md">
                            <div class="search col-lg-12">
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iRDFrom">RD:</label></div>
                                <div class="col-lg-8">
                                  <input type="number" min="0" name="RDFrom" id="iRDFrom" placeholder="from" class="col-lg-6" ref="rdFrom" @keydown.enter="searchPosts">
                                  <input type="number" min="0" name="RDTo" id="iRDTo" placeholder="to" class="col-lg-6" ref="rdTo" @keydown.enter="searchPosts">
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iTFFrom">TF:</label></div>
                                <div class="col-lg-8">
                                  <input type="number" min="0" name="TFFrom" id="iTFFrom" placeholder="from" class="col-lg-6" ref="tfFrom" @keydown.enter="searchPosts">
                                  <input type="number" min="0" name="TFTo" id="iTFTo" placeholder="to" class="col-lg-6" ref="tfTo" @keydown.enter="searchPosts">
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iDAFrom">DA:</label></div>
                                <div class="col-lg-8">
                                  <input type="number" min="0" name="DAFrom" id="iDAFrom" placeholder="from" class="col-lg-6" ref="daFrom" @keydown.enter="searchPosts">
                                  <input type="number" min="0" name="DATo" id="iDATo" placeholder="to" class="col-lg-6" ref="daTo" @keydown.enter="searchPosts">
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row m-t-md">
                            <div class="search col-lg-12">
                              <div class="col-lg-4">
                                <div class="col-lg-4"><label for="iRDFrom">Categories:</label></div>
                                <div class="col-lg-8">
                                  <v-select multiple="multiple" v-model="selectedCategories" :options="categories" name="categories"></v-select>
                                </div>
                              </div>
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    </form>
<!--                    <div class="input-group">
                      <input type="text" class="form-control" ref="searchPosts" @keydown.enter="searchPosts">
                      <span class="input-group-append"><button type="button" class="btn btn-primary" @click="searchPosts">Search!</button></span>
                    </div> !-->
<!--                    <div class="row" v-if="searchResults.length">
                      <table class="table small table-striped table-bordered table-hover m-b-xs m-t-md">
                        <thead>
                        <tr>
                          <th>Title</th>
                          <th>Lang</th>
                          <th>Added</th>
                          <th>Modified</th>
                          <th>Category</th>
                          <th>RD</th>
                          <th>TF</th>
                          <th>DA</th>
                          <th>Site</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="post in searchResults" v-bind:key="post.id" @click="loadPost(post.site.id, post.postId)">
                          <td>
                            <span class="label" v-bind:class="getClassType(post.type)">{{ post.type }}</span>
                            {{ post.title }}
                          </td>
                          <td>{{ post.lang }}</td>
                          <td>{{ $moment(post.postDate.date).format('DD.MM.YYYY') }}</td>
                          <td>{{ $moment(post.modified.date).calendar() }}</td>
                          <td>{{ post.site.stats.ttf0 }}</td>
                          <td>{{ post.site.stats.rd }}</td>
                          <td>{{ post.site.stats.tf }}</td>
                          <td>{{ post.site.stats.da }}</td>
                          <td>{{ post.site.url }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div> !-->
                    <div class="row">
                      <auto-orders :auto-replace-orders="this.autoReplaceOrders" @previewFulfilment="previewFulfilment"></auto-orders>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <table class="table small m-b-xs">
                      <tbody>
                      <tr>
                        <td>Id</td>
                        <td><strong>{{ order.id }}</strong></td>
                      </tr>
                      <tr>
                        <td>Link</td>
                        <td>
                          <strong>{{ order.link }}</strong>
                        </td>
                      <tr>
                        <td>Anchor</td>
                        <td><strong>{{ order.anchor }}</strong></td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td>{{ $moment(order.date.date).format('DD.MM.YYYY') }}</td>
                      </tr>
                      <tr>
                        <td>Count</td>
                        <td>{{ order.count }}</td>
                      </tr>
                      <tr>
                        <td>Placed</td>
                        <td><strong>{{ 0 }}</strong></td>
                      </tr>
                      <tr>
                        <td>Remaining</td>
                        <td>{{ order.count }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ibox">
            <div class="col-lg-12">
              <div class="ibox" v-if="order">
                <placed-links :placements="autoPlacedLinks" v-if="autoPlacedLinks"></placed-links>
              </div>
            </div>
          </div>
          <div class="ibox">
            <div class="ibox-title">Open Orders</div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-md-12" v-if="!orders.open.length">
                  There are currently no open orders.<br>
                  Try and get some business.
                </div>
                <div class="col-md-12" v-else>
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>Placed</th>
                      <th>Anchor</th>
                      <th>Link</th>
                      <th>Order</th>
                      <th>Placed</th>
                      <th>Remaining</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="order in orders.open" v-bind:key="order.open.id" @click="loadOrder(order.client.id, order.id)">
                      <td>{{ $moment(order.date.date).format('DD.MM.YYYY') }}</td>
                      <td>{{ order.anchor }}</td>
                      <td>{{ order.link }}</td>
                      <td>{{ order.count }}</td>
                      <td>{{ order.placedLinksCount }}</td>
                      <td>{{ order.count - order.placedLinksCount }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ibox" v-if="fulfilledOrders">
        <div class="ibox-title">Fulfilled Orders</div>
        <div class="ibox-content">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import tinymce from '@tinymce/tinymce-vue'
import summernote from '../../../components/Addons/Summernote'
import Placements from './Placements'
import AutoFulfilOrders from './AutoFulfilOrders'
import PostSearch from './PostSearch'

export default {
  name: 'Client',
  data () {
    return {
      loaded: false,
      client: {},
      fulfilledOrders: false,
      orders: {
        open: [],
        fulfilled: []
      },
      clientId: null,
      order: null,
      searchResults: [],
      post: null,
      languages: [],
      postLoaded: false,
      orderAutoReplace: [],
      autoReplaceData: {
        filters: []
      },
      categories: [],
      selectedCategories: [],
      file: null,
      autoReplaceOrders: [],
      autoPlacedLinks: []
    }
  },
  components: {
    editor: tinymce,
    summernote: summernote,
    'placed-links': Placements,
    'auto-orders': AutoFulfilOrders,
    'post-search': PostSearch
  },
  mounted () {
    this.clientId = this.$route.params.clientId
    this.loadClient(this.clientId)
    this.loadOrders(this.clientId)
    this.getLangs()
    this.getCategories()
    if (this.$route.params.orderId) {
      this.loadOrder(this.clientId, this.$route.params.orderId)
      this.getAutoPlacedLinks(this.$route.params.orderId)
      this.getAutoReplaceOrders(this.$route.params.orderId)
    }
  },
  methods: {
    handleFile () {
      this.file = this.$refs.oCsvFile.files[0]
      console.log(this.file)
    },
    uploadCsvFile () {
      let formData = new FormData()
      formData.append('file', this.file)
      axios.post(process.env.API + '/client/' + this.clientId + '/order/' + this.$route.params.orderId + '/upload-autoorder-csv',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
        this.getAutoReplaceOrders(this.$route.params.orderId)
        $('#modal-upload-csv').modal('hide')
      }).catch(e => {
        console.log(e)
      })
    },
    getAutoReplaceOrders (orderId) {
      axios.get(process.env.API + '/client/' + this.clientId + '/order/' + orderId + '/autoorders')
        .then(response => {
          this.autoReplaceOrders = response.data
        })
    },
    getAutoPlacedLinks (orderId) {
      axios.get(process.env.API + '/order/' + orderId + '/placed-links')
        .then(response => {
          this.autoPlacedLinks = response.data
        })
    },
    getLangs () {
      this.languages = []
      axios.get(process.env.API + '/languages').then(response => {
        this.languages = response.data.data
      })
    },
    getCategories () {
      // axios.get(process.env.API + '/categories').then(response => {
      axios.get('http://wp.api/categories').then(response => {
        for (let key in response.data) {
          this.categories.push({
            value: key,
            label: response.data[key]
          })
        }
      })
    },
    getClassType (type) {
      return type === 'post' ? 'label-primary' : 'label-secondary'
    },
    loadClient (id) {
      axios.get(process.env.API + '/client/' + id)
        .then((response) => {
          this.client = response.data
        })
    },
    loadOrders (client) {
      axios.get(process.env.API + '/client/' + client + '/orders/all')
        .then((response) => {
          this.orders.open = []
          this.orders.fulfilled = []
          response.data.data.forEach((order) => {
            this.orders[order.open ? 'open' : 'fulfilled'].push(order)
          })
        })
    },
    loadOrder (clientId, orderId) {
      axios.get(process.env.API + '/client/' + clientId + '/order/' + orderId)
        .then((response) => {
          this.order = response.data
          this.$router.push({ path: '/client/' + clientId + '/' + orderId })
        })
    },
    searchPosts () {
      let cats = []
      this.selectedCategories.forEach((obj) => {
        cats.push(obj.label)
      })
      axios.get(process.env.API + '/find-post?query=' + this.$refs.searchPosts.value + '&order=' + this.order.id + '&' + $('#postRestrictions').serialize() + '&categories=' + cats).then(response => {
        this.searchResults = []
        if (response.data) {
          response.data.forEach((post) => {
            this.searchResults.push(post)
          })
        }
      })
    },
    loadPost (siteId, postId) {
      axios.get(process.env.API + '/site/' + siteId + '/post/' + postId)
        .then((response) => {
          this.post = response.data
          this.postLoaded = true
          $('#modal-form').modal()
          this.post.content = this.autop(response.data.content)
        })
    },
    savePost () {
      console.log(this.post)
      axios.patch(process.env.API + '/post', {
        site: this.post.site.id,
        post: this.post.postId,
        content: this.removep(this.post.content),
        order: this.order.id
      })
        .then((response) => {
          this.loadOrders(this.clientId)
          this.loadOrder(this.clientId, this.order.id)
          this.$router.push({path: `/client/${this.clientId}`})
          this.searchPosts()
          $('#modal-form').modal('hide')
        })
        .catch(e => {
          console.log(e)
        })
    },
    addOrder () {
      axios.post(process.env.API + '/client/' + this.client.id + '/order', {
        link: this.$refs.oLink.value,
        count: this.$refs.oNumber.value,
        anchor: this.$refs.oAnchor.value,
        client: this.client.id
      })
        .then(response => {
          this.loadOrders(this.client.id)
          $('#modal-order').modal('hide')
        })
        .catch(e => {
          console.log(e)
        })
    },
    addAutoReplace () {
      axios.post(process.env.API + '/order/' + this.order.id + '/auto-rep', {
        search: this.$refs.oAutoSearch.value,
        replace: this.$refs.oAutoReplace.value,
        link: this.$refs.oAutoLink.value,
        count: this.$refs.oAutoNumber.value
      })
        .then(response => {
          this.loadOrder(this.client.id, this.order.id)
          $('#modal-replace').modal('hide')
          $('#modal-replace input').val('')
        })
        .catch(e => {
          console.log(e)
        })
    },
    deleteReplacement (id) {
      if (confirm('Delete replacement?')) {
        axios.delete(process.env.API + '/order/' + this.order.id + '/autoorder/' + id)
          .then(response => {
            this.loadOrder(this.client.id, this.order.id)
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    previewFulfilment () {
      console.log('previewing')
      $('#modal-preview-auto').modal('show')
      this.autoReplaceData = {
        filters: {
          typePost: $('#postRestrictions #typePost').is(':checked') || !$('#postRestrictions #typePage').is(':checked'),
          typePage: $('#postRestrictions #typePage').is(':checked') || !$('#postRestrictions #typePost').is(':checked'),
          lang: $('#postRestrictions [name=language]').val(),
          rdFrom: $('#postRestrictions [name=RDFrom]').val(),
          rdTo: $('#postRestrictions [name=RDTo]').val(),
          tfFrom: $('#postRestrictions [name=TFFrom]').val(),
          tfTo: $('#postRestrictions [name=TFTo]').val(),
          daFrom: $('#postRestrictions [name=DAFrom]').val(),
          daTo: $('#postRestrictions [name=DATo]').val()
        },
        replacements: this.order.autoReplace
      }
    },
    fulfilOrder () {
      axios.post(process.env.API + '/order/' + this.order.id + '/auto-fulfil', {
        filters: $('#postRestrictions').serialize()
      })
        .then(resp => {
          $('#modal-preview-auto').modal('hide')
        })
        .catch(e => {
          console.log(e)
        })
      console.log(this.autoReplaceData)
    },
    removep (html) {
      let blocklist = 'blockquote|ul|ol|li|dl|dt|dd|table|thead|tbody|tfoot|tr|th|td|h[1-6]|fieldset|figure'
      let blocklist1 = blocklist + '|div|p'
      let blocklist2 = blocklist + '|pre'
      let preserverLinebreaks = false
      let preserveBr = false
      let preserve = []

      if (!html) {
        return ''
      }

      // Protect script and style tags.
      if (html.indexOf('<script') !== -1 || html.indexOf('<style') !== -1) {
        html = html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/g, function (match) {
          preserve.push(match)
          return '<wp-preserve>'
        })
      }

      // Protect pre tags.
      if (html.indexOf('<pre') !== -1) {
        preserverLinebreaks = true
        html = html.replace(/<pre[^>]*>[\s\S]+?<\/pre>/g, function (a) {
          a = a.replace(/<br ?\/?>(\r\n|\n)?/g, '<wp-line-break>')
          a = a.replace(/<\/?p( [^>]*)?>(\r\n|\n)?/g, '<wp-line-break>')
          return a.replace(/\r?\n/g, '<wp-line-break>')
        })
      }

      // Remove line breaks but keep <br> tags inside image captions.
      if (html.indexOf('[caption') !== -1) {
        preserveBr = true
        html = html.replace(/\[caption[\s\S]+?\[\/caption\]/g, function (a) {
          return a.replace(/<br([^>]*)>/g, '<wp-temp-br$1>').replace(/[\r\n\t]+/, '')
        })
      }

      // Normalize white space characters before and after block tags.
      html = html.replace(new RegExp('\\s*</(' + blocklist1 + ')>\\s*', 'g'), '</$1>\n')
      html = html.replace(new RegExp('\\s*<((?:' + blocklist1 + ')(?: [^>]*)?)>', 'g'), '\n<$1>')

      // Mark </p> if it has any attributes.
      html = html.replace(/(<p [^>]+>.*?)<\/p>/g, '$1</p#>')

      // Preserve the first <p> inside a <div>.
      html = html.replace(/<div( [^>]*)?>\s*<p>/gi, '<div$1>\n\n')

      // Remove paragraph tags.
      html = html.replace(/\s*<p>/gi, '')
      html = html.replace(/\s*<\/p>\s*/gi, '\n\n')

      // Normalize white space chars and remove multiple line breaks.
      html = html.replace(/\n[\s\u00a0]+\n/g, '\n\n')

      // Replace <br> tags with line breaks.
      html = html.replace(/(\s*)<br ?\/?>\s*/gi, function (match, space) {
        if (space && space.indexOf('\n') !== -1) {
          return '\n\n'
        }

        return '\n'
      })

      // Fix line breaks around <div>.
      html = html.replace(/\s*<div/g, '\n<div')
      html = html.replace(/<\/div>\s*/g, '</div>\n')

      // Fix line breaks around caption shortcodes.
      //    html = html.replace(/\s*\[caption([^\[]+)\[\/caption\]\s*/gi, '\n\n[caption$1[/caption]\n\n')
      html = html.replace(/caption\]\n\n+\[caption/g, 'caption]\n\n[caption')

      // Pad block elements tags with a line break.
      html = html.replace(new RegExp('\\s*<((?:' + blocklist2 + ')(?: [^>]*)?)\\s*>', 'g'), '\n<$1>')
      html = html.replace(new RegExp('\\s*</(' + blocklist2 + ')>\\s*', 'g'), '</$1>\n')

      // Indent <li>, <dt> and <dd> tags.
      html = html.replace(/<((li|dt|dd)[^>]*)>/g, ' \t<$1>')

      // Fix line breaks around <select> and <option>.
      if (html.indexOf('<option') !== -1) {
        html = html.replace(/\s*<option/g, '\n<option')
        html = html.replace(/\s*<\/select>/g, '\n</select>')
      }

      // Pad <hr> with two line breaks.
      if (html.indexOf('<hr') !== -1) {
        html = html.replace(/\s*<hr( [^>]*)?>\s*/g, '\n\n<hr$1>\n\n')
      }

      // Remove line breaks in <object> tags.
      if (html.indexOf('<object') !== -1) {
        html = html.replace(/<object[\s\S]+?<\/object>/g, function (a) {
          return a.replace(/[\r\n]+/g, '')
        })
      }

      // Unmark special paragraph closing tags.
      html = html.replace(/<\/p#>/g, '</p>\n')

      // Pad remaining <p> tags whit a line break.
      html = html.replace(/\s*(<p [^>]+>[\s\S]*?<\/p>)/g, '\n$1')

      // Trim.
      html = html.replace(/^\s+/, '')
      html = html.replace(/[\s\u00a0]+$/, '')

      if (preserverLinebreaks) {
        html = html.replace(/<wp-line-break>/g, '\n')
      }

      if (preserveBr) {
        html = html.replace(/<wp-temp-br([^>]*)>/g, '<br$1>')
      }

      // Restore preserved tags.
      if (preserve.length) {
        html = html.replace(/<wp-preserve>/g, function () {
          return preserve.shift()
        })
      }

      return html
    },
    autop (text) {
      let preserveLinebreaks = false
      let preserveBr = false
      let blocklist = 'table|thead|tfoot|caption|col|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre' +
        '|form|map|area|blockquote|address|math|style|p|h[1-6]|hr|fieldset|legend|section' +
        '|article|aside|hgroup|header|footer|nav|figure|figcaption|details|menu|summary'

      // Normalize line breaks.
      text = text.replace(/\r\n|\r/g, '\n')

      // Remove line breaks from <object>.
      if (text.indexOf('<object') !== -1) {
        text = text.replace(/<object[\s\S]+?<\/object>/g, function (a) {
          return a.replace(/\n+/g, '')
        })
      }

      // Remove line breaks from tags.
      text = text.replace(/<[^<>]+>/g, function (a) {
        return a.replace(/[\n\t ]+/g, ' ')
      })

      // Preserve line breaks in <pre> and <script> tags.
      if (text.indexOf('<pre') !== -1 || text.indexOf('<script') !== -1) {
        preserveLinebreaks = true
        text = text.replace(/<(pre|script)[^>]*>[\s\S]*?<\/\1>/g, function (a) {
          return a.replace(/\n/g, '<wp-line-break>')
        })
      }

      if (text.indexOf('<figcaption') !== -1) {
        text = text.replace(/\s*(<figcaption[^>]*>)/g, '$1')
        text = text.replace(/<\/figcaption>\s*/g, '</figcaption>')
      }

      // Keep <br> tags inside captions.
      if (text.indexOf('[caption') !== -1) {
        preserveBr = true

        text = text.replace(/\[caption[\s\S]+?\[\/caption\]/g, function (a) {
          a = a.replace(/<br([^>]*)>/g, '<wp-temp-br$1>')

          a = a.replace(/<[^<>]+>/g, function (b) {
            return b.replace(/[\n\t ]+/, ' ')
          })

          return a.replace(/\s*\n\s*/g, '<wp-temp-br />')
        })
      }

      text = text + '\n\n'
      text = text.replace(/<br \/>\s*<br \/>/gi, '\n\n')

      // Pad block tags with two line breaks.
      text = text.replace(new RegExp('(<(?:' + blocklist + ')(?: [^>]*)?>)', 'gi'), '\n\n$1')
      text = text.replace(new RegExp('(</(?:' + blocklist + ')>)', 'gi'), '$1\n\n')
      text = text.replace(/<hr( [^>]*)?>/gi, '<hr$1>\n\n')

      // Remove white space chars around <option>.
      text = text.replace(/\s*<option/gi, '<option')
      text = text.replace(/<\/option>\s*/gi, '</option>')

      // Normalize multiple line breaks and white space chars.
      text = text.replace(/\n\s*\n+/g, '\n\n')

      // Convert two line breaks to a paragraph.
      text = text.replace(/([\s\S]+?)\n\n/g, '<p>$1</p>\n')

      // Remove empty paragraphs.
      text = text.replace(/<p>\s*?<\/p>/gi, '')

      // Remove <p> tags that are around block tags.
      text = text.replace(new RegExp('<p>\\s*(</?(?:' + blocklist + ')(?: [^>]*)?>)\\s*</p>', 'gi'), '$1')
      text = text.replace(/<p>(<li.+?)<\/p>/gi, '$1')

      // Fix <p> in blockquotes.
      text = text.replace(/<p>\s*<blockquote([^>]*)>/gi, '<blockquote$1><p>')
      text = text.replace(/<\/blockquote>\s*<\/p>/gi, '</p></blockquote>')

      // Remove <p> tags that are wrapped around block tags.
      text = text.replace(new RegExp('<p>\\s*(</?(?:' + blocklist + ')(?: [^>]*)?>)', 'gi'), '$1')
      text = text.replace(new RegExp('(</?(?:' + blocklist + ')(?: [^>]*)?>)\\s*</p>', 'gi'), '$1')

      text = text.replace(/(<br[^>]*>)\s*\n/gi, '$1')

      // Add <br> tags.
      text = text.replace(/\s*\n/g, '<br />\n')

      // Remove <br> tags that are around block tags.
      text = text.replace(new RegExp('(</?(?:' + blocklist + ')[^>]*>)\\s*<br />', 'gi'), '$1')
      text = text.replace(/<br \/>(\s*<\/?(?:p|li|div|dl|dd|dt|th|pre|td|ul|ol)>)/gi, '$1')

      // Remove <p> and <br> around captions.
      // text = text.replace(/(?:<p>|<br ?\/?>)*\s*\[caption([^\[]+)\[\/caption\]\s*(?:<\/p>|<br ?\/?>)*/gi, '[caption$1[/caption]')

      // Make sure there is <p> when there is </p> inside block tags that can contain other blocks.
      text = text.replace(/(<(?:div|th|td|form|fieldset|dd)[^>]*>)(.*?)<\/p>/g, function (a, b, c) {
        if (c.match(/<p( [^>]*)?>/)) {
          return a
        }
        return b + '<p>' + c + '</p>'
      })

      // Restore the line breaks in <pre> and <script> tags.
      if (preserveLinebreaks) {
        text = text.replace(/<wp-line-break>/g, '\n')
      }

      // Restore the <br> tags in captions.
      if (preserveBr) {
        text = text.replace(/<wp-temp-br([^>]*)>/g, '<br$1>')
      }

      return text
    }
  }
}
</script>
<style scoped>
.table-hover > tbody > tr {
  cursor: pointer;
}
.input-group {
  position: relative;
  display: flex;
  width: 100%;
}
.input-group>.input-group-append>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
#modal-form .modal-dialog{
  width: 80%;
  min-height: 500px;
}
#modal-form .modal-content {
  min-height: 580px;
}
#editorRow {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Client/Client.vue